import { render, staticRenderFns } from "./LinkChampionTrend.vue?vue&type=template&id=78b31933&"
import script from "./LinkChampionTrend.vue?vue&type=script&lang=js&"
export * from "./LinkChampionTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports